import { useRefGetter } from '../../use';
import { useEffect, useRef } from 'react';
import { addEventListener, isClient, removeEventListener } from '../../co-dom';
import { useContainer } from './useContainer';
export function useContainerScroll(element, enable, onScroll) {
  var onScrollGetter = useRefGetter(onScroll);
  var elementGetter = useContainer(element);
  var enableGetter = useRefGetter(enable);
  var initRef = useRef(false);
  var frame = useRef(0);
  useEffect(function () {
    if (!enableGetter()()) {
      return;
    }

    initRef.current = true;

    var callback = function callback(e) {
      cancelAnimationFrame(frame.current);
      frame.current = requestAnimationFrame(function () {
        var target = e.target;
        var handler = onScrollGetter();
        var elem = elementGetter();

        if (elem && target.contains(elem)) {
          handler(e);
        }
      });
    };

    if (isClient()) {
      addEventListener(document, 'capture:scroll', callback, true);
      return function () {
        cancelAnimationFrame(frame.current);
        removeEventListener(document, 'capture:scroll', callback);
      };
    }
  }, [initRef.current, enableGetter()()]);
}